import { render } from "./BackgroundEditor.vue?vue&type=template&id=6ff7dd6d&scoped=true"
import script from "./BackgroundEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundEditor.vue?vue&type=script&lang=js"

import "./BackgroundEditor.vue?vue&type=style&index=0&id=6ff7dd6d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ff7dd6d"

export default script